export function buildManageAllPageQueryV1(workspaceId: number, strategyId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.CorporateAttributes.Queries.ManageAllPageQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'StrategyId': strategyId,
	}
}